import {Component, Input, OnInit} from '@angular/core';
import {Helper} from '../../../../app/utils/helper.module';
import {Contact} from "./contact";
import {EventsService} from "../../../bo/events/events.service";
import {TranslateService} from "@ngx-translate/core";
import {FonctionUtiles} from "../../../utils/fonctionsUtiles";

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
  providers: [EventsService]
})
export class ContactComponent implements OnInit {

  contact:Contact = new Contact();
  errors:any = new Array();
  pendingRequest:boolean = false;
  done:boolean = false;
  incomplete_form:string;
  error_message:string;
  @Input() showBanner:boolean = true;
  @Input() textAreaHasHeigh155:boolean = false;

  constructor(private eventservice :EventsService,private translateService:TranslateService,private fonctionUtils:FonctionUtiles) {

  }

  ngOnInit() {
    this.translateService.get('front_contact.incomplete_form').subscribe(
      value => {
        this.incomplete_form = value;
      }
    );
    this.translateService.get('front_contact.an_error_occured').subscribe(
      value => {
        this.error_message = value;
      }
    )

  }

  onSubmit(validity) {

    this.contact.lang = this.fonctionUtils.retrieve('curentLang');
    if(this.validation(validity)) {

       this.send();
    }
  }
  displayErrors() {
    window.scrollTo(0,0);
  }

  validation(validity): boolean {
    // re init errors
    this.errors = new Array();

    if(this.contact.destinataire == "" || this.contact.email == "" || this.contact.last_name == "" ||
      this.contact.first_name == "" || this.contact.destinataire == "-1") {
      this.errors.push('formulaire incomplet')
    }

    if(this.errors.length) {
      this.displayErrors();
      return false;
    }
    // no errors
    return true;
  }

  send() {
    this.pendingRequest=true;
    this.eventservice.contactSend(this.contact)
      .then(res => {
        this.pendingRequest=false;
        this.done=true
      })
      .catch(error => {
        this.pendingRequest=false;
        this.done=false;
        this.pendingRequest=false;
        this.errors.push('une erreur s\'est produite');
        this.displayErrors();
        console.log(error);
      });
  }

}
